import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';
import { useTenant } from '../../hooks/use-tenant';
import { useTranslation } from 'react-i18next';

export function AuthCallbackPage() {
  const { t } = useTranslation('identity');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setTokenFromCallback } = useAuth();
  const { setDomain } = useTenant();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');
    const domainParam = searchParams.get('domain');

    if (error) {
      // Si hay un error, redirigir al login con el mensaje
      navigate('/login', { 
        replace: true,
        state: { error: t('auth.callback.microsoftError') }
      });
      return;
    }

    if (token) {
      // Si hay un dominio en los params, guardarlo primero
      if (domainParam) {
        setDomain(domainParam);
      }
      
      // Guardar el token y redirigir al dashboard
      // Pasar el dominio como parámetro para asegurar que esté disponible
      setTokenFromCallback(token, domainParam || undefined)
        .then(() => {
          navigate('/', { replace: true });
        })
        .catch(() => {
          navigate('/login', { 
            replace: true,
            state: { error: t('auth.callback.tokenError') }
          });
        });
    } else {
      // Si no hay token, redirigir al login
      navigate('/login', { replace: true });
    }
  }, [navigate, searchParams, setDomain, setTokenFromCallback, t]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-surface-page text-content-primary">
      <div className="text-center">
        <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
        <p className="text-sm text-content-secondary">{t('auth.callback.loading')}</p>
      </div>
    </div>
  );
}
